import AbstractQueue from '@/host/service/queues/AbstractQueue'

export default class GhostQueue extends AbstractQueue {}
